import { Component } from '@angular/core';


@Component({
  selector: "app-migrated-claim",
  template: "<router-outlet></router-outlet>",
})
export class MigratedClaimComponent { }



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/migrated-claim/migrated-claim.component.ts